import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { IconBarcode, IconQrcode, IconCreditCard, IconCreditCardFilled, IconInfoCircleFilled, IconCirclePercentageFilled, IconArrowBigRightFilled  } from '@tabler/icons-vue'; 

// Importe a imagem (certifique-se que o caminho está correto)
import logo from '@/assets/img/ico.png';

const setFavicon = (iconUrl) => {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/png';
  link.href = iconUrl;
  
  const existingFavicon = document.querySelector('link[rel="icon"]');
  if (existingFavicon) {
    document.head.removeChild(existingFavicon);
  }
  
  document.head.appendChild(link);
};

const app = createApp(App)

app.component('IconBarcode', IconBarcode);
app.component('IconQrcode', IconQrcode);
app.component('IconCreditCard', IconCreditCard);
app.component('IconCreditCardFilled', IconCreditCardFilled);
app.component('IconInfoCircleFilled', IconInfoCircleFilled);
app.component('IconCirclePercentageFilled', IconCirclePercentageFilled);
app.component('IconArrowBigRightFilled', IconArrowBigRightFilled);

// Configurar favicon com a imagem importada
setFavicon(logo);

app.use(router)
app.mount('#app')